import { useCallback, useSyncExternalStore } from "react"

export function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query)

      mediaQueryList.addEventListener("change", onStoreChange)

      return () => {
        mediaQueryList.removeEventListener("change", onStoreChange)
      }
    },
    [query]
  )

  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query]
  )

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}

export type DesktopBreakpoint = "lg" | "xl"

const DESKTOP_QUERIES: Record<DesktopBreakpoint, string> = {
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1280px)",
}

export function useIsDesktop({
  breakpoint = "xl",
}: { breakpoint?: DesktopBreakpoint } = {}) {
  return useMediaQuery(DESKTOP_QUERIES[breakpoint])
}
